module.exports = __webpack_public_path__ + "src/images/products/trendsetter/107_Reverse Weave Tie Dye Shirt.png";